/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { MySubscriptionStatusResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMySubscriptionStatus: build.query<MySubscriptionStatusResponse, void>({
      query: () => ({ method: 'GET', url: `/v1/billing/me` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getMySubscriptionStatusApi };
export const { useGetMySubscriptionStatusQuery, useLazyGetMySubscriptionStatusQuery } = injectedRtkApi;
